module.exports = __webpack_public_path__ + "img/39.3966217b.jpg";